import http from '@/biz/http.mjs'

export default {
    create: (data) => http.post('/rulemRm/addRulemRm', data),

    publish: ({pkid, ...data}) => http.post(
        '/rulemRm/rlsRulemRm',
        {rulemRms: [{pkid}], ...data}
    ),

    pull: ({pkid}) => http.get('/rulemRm/loadDp', {pkid}),
    push: (data) => http.post('/rulemRm/modifyDp', data),
    read: ({pkid}) => http.get('/rulemRm/oneRulemRm', {pkid}),
    readList: (args) => http.get('/rulemRm/listRulemRm', args),

    revise: ({pkid, ...data}) => http.post(
        '/rulemRm/reviseRulemRm',
        {rulemRms: [{pkid}], ...data}
    ),

    update: (data) => http.post('/rulemRm/modifyRulemRm/', data),
    updateMap: (data) => http.post('/rulemRm/saveMap', data),
}
